import { Injectable } from "@angular/core";
import { DocumentRef } from "@obg/ngx.global.evo";

export abstract class ReferrerService {
	abstract getReferrer(): string;
}

@Injectable()
export class ClientReferrerService implements ReferrerService {
	constructor(private documentRef: DocumentRef) {}

	getReferrer(): string {
		return this.documentRef.native.referrer;
	}
}
